/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type UpdateViewPathParams = NonNullable<operations['updateView']['parameters']['path']>;

export type UpdateViewRequestBody = OperationRequestBodyContent<operations['updateView']>;

export interface Input extends UpdateViewPathParams {
  apiVersion?: string;
  body: UpdateViewRequestBody;
  header: NonNullable<operations['updateView']['parameters']['header']>;
}

export async function updateView(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/views/{viewKey}', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
